export default __webpack_public_path__ + "static/logo-chat-f5897e08ec93540fdb3b0fe18fecec38.svg";